
















export default

	computed:
		footerData: -> @$store.state.globals.footer

